@if (allowLoader() && showLoader()) {
  <motif-progress-loader [show]="true" [fullScreen]="true"></motif-progress-loader>
} @else {
  <motif-theme [variant]="themeVariant()"></motif-theme>
  <router-outlet />
}
